/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Application_Status_Waiting7Inputs */

const en_application_status_waiting7 = /** @type {(inputs: Application_Status_Waiting7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waiting`)
};

const de_application_status_waiting7 = /** @type {(inputs: Application_Status_Waiting7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wartend`)
};

/**
* | output |
* | --- |
* | "Waiting" |
*
* @param {Application_Status_Waiting7Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const application_status_waiting7 = /** @type {((inputs?: Application_Status_Waiting7Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Application_Status_Waiting7Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_application_status_waiting7(inputs)
	return en_application_status_waiting7(inputs)
});
export { application_status_waiting7 as "application_status_WAITING" }